<template>
  <div id="home">

    <div class="content">
      <div style="display: flex;align-items: center;justify-content: space-between;">
        <div class="title">
          Call Inquiries
        </div>
      </div>

      <div class="center" style="display: flex;justify-content: space-between;align-items: center;flex-wrap:wrap;">
        <div>
          <el-date-picker style="width: 100%;"
            v-model="value"
            type="daterange"
            :clearable="false"
            @change="changeTime"
            format="MM/dd/yyyy"
            placement="bottom-start">
          </el-date-picker>
          <i class="el-icon-arrow-down" style="color:gray;position: absolute;margin-left: -30px;margin-top: 12px;"></i>
        </div>
      </div>
      <div class="pannel">
        <div class="item">
          <div class="div">
            <span class="span">
              <i class="el-icon-phone-outline"></i>
            </span>
            <p>
              Total Calls
            </p>
          </div>
          <div class="div">
            <span>{{dashBoardDataMain.total_calls}}</span>
          </div>
        </div>
        <div class="item">
          <div class="div">
            <span class="span">
              <i class="el-icon-check"></i>
            </span>
            <p>
              Answered Calls
            </p>
          </div>
          <div class="div">
            <span>{{dashBoardDataMain.answered_calls}}</span>
          </div>
        </div>
        <div class="item">
          <div class="div">
            <span class="span">
              <i class="el-icon-close"></i>
            </span>
            <p>
              Missed Calls
            </p>
          </div>
          <div class="div">
            <span>{{dashBoardDataMain.missed_calls}}</span>
          </div>
        </div>
        <div class="item">
          <div class="div">
            <span class="span">
              <i class="el-icon-star-off"></i>
            </span>
            <p>
              Avg. Quality Score
            </p>
          </div>
          <div class="div">
            <span v-if="dashBoardDataMain.avg_quality_score">{{dashBoardDataMain.avg_quality_score_str}}</span>
            <span v-else>0</span>
          </div>
        </div>
      </div>
      <div class="contentBoard callDistribution">
        <h4 class="pageH4">Call Distribution</h4>
        <div class="cdClass">
          <div class="huan">
            <div class="item">
              <div style="display: flex;justify-content: center;">
                <span style="line-height: 200px;position: absolute;z-index: 1;">{{dashBoardDataMain.answered_calls}}</span>
              </div>
              <div id="myPie1" style="height: 200px;"></div>
              <p style="text-align: center;color:#5EB1FF;">Answered <span style="color:#2D3648;">({{this.dashBoardDataCallDistribution.answered_rate}}%)</span></p>
            </div>
            <div class="item">
              <div style="display: flex;justify-content: center;">
                <span style="line-height: 200px;position: absolute;z-index: 1;">{{dashBoardDataMain.missed_calls}}</span>
              </div>
              <div id="myPie2" style="height: 200px;"></div>
              <p style="text-align: center;color:#D35A5A;">Missed <span style="color:#2D3648;">({{this.dashBoardDataCallDistribution.missed_rate}}%)</span></p>
            </div>
          </div>
          <div class="grid">
            <div>
              Total Duration
              <p>
                <b v-if="dash_board_total_duration">{{dash_board_total_duration}}</b>
                <b v-else>00:00</b>
              </p>
            </div>
            <div>
              Avg Duration
              <p>
                <b v-if="dash_board_avg_duration">{{dash_board_avg_duration}}</b>
                <b v-else>00:00</b>
              </p>
            </div>
          </div>
        </div>


      </div>
      <div class="contentBoard">
        <h4 class="pageH4">Weekly Call Trend</h4>
        <div id="echarts_div" style="height: 300px;"></div>
      </div>

      <div class="contentBoard sources">
        <h4 class="pageH4">Top Call Sources</h4>
        <div class="item" v-for="(item,index) of dashBoardDataCallSources" :key="index">
          <div class="info">
            {{item.name}}
            <b>{{item.value}}</b>
          </div>
          <div class="bar">
            <div :style="'width:' + item.rate + '%;'"></div>
          </div>
        </div>
      </div>

      <div class="contentBoard actionItem">
        <h4 class="pageH4">Action Items
        <span>
          <a @click="go_show_all_action">View All</a>
        </span>
        </h4>
        <div class="grid">
          <div class="item" style="background-color: #fff2f2;" v-for="(item,index) of action_item_list" :key="index">
            <div class="info" @click.stop="show_edit(item.call_sid)" style="cursor: pointer;">
              {{item.action_items}}
              <div @click.stop="remove_item(item,index)" class="dismiss_btn">Dismiss</div>
            </div>
            Due: {{due_time_show(item.due_datetime)}}
          </div>
          <!-- <div class="item" style="background-color: #fffce9;">
            <div class="info">
              Follow up with missed calls
              <i class="el-icon-close"></i>
            </div>
            Due: Today
          </div>
          <div class="item" style="background-color: #edf9f1;">
            <div class="info">
              Follow up with missed calls
              <i class="el-icon-close"></i>
            </div>
            Due: Today
          </div> -->
        </div>
      </div>
      <div style="display: flex;flex-direction: column;background-color: #ffffff;">
        <h4 class="pageH4" style="background-color: #ffffff;padding:30px 30px 10px 30px;">Recent Calls
        <span>
          <a @click="go_show_call_list">View All</a>
          <i class="el-icon-s-tools setting" style="font-size: 16px;font-weight: bold;cursor: pointer;color: #777777;padding-left:10px;" @click="show_setting_cols"></i>
        </span>
        </h4>
      </div>
      <el-table
          v-loading="table_loading"
          :data="tableData"
          @row-click="rowClick"
          @sort-change="order_change"
          class="round-header-table"
          :header-cell-style="{'background-color': '#A0ABC0', 'color': '#FFFFFF', 'font-weight': 'bold'}"
          :cell-style="{ fontSize: '14px'}"
          border
          style="width: 100%;">

          <el-table-column
            v-if="judge_show('CALL_DATETIME')"
            align="left"
            min-width="150"
            sortable
            prop="date"
            label="Date & Time">
            <template slot-scope="scope">
              {{moment(scope.row.created_datetime).format('MM/DD/YY')}}<br/>
              {{moment(scope.row.created_datetime).format('HH:mm:ss')}}
            </template>
          </el-table-column>
          <el-table-column
            v-if="judge_show('CALL_FROM')"
            align="center"
            prop="phone_from"
            min-width="180"
            label="Mobile Phone">
            <template slot-scope="scope" v-if="scope.row.phone_from">
              {{process_phone_number_format(scope.row.phone_from)}}
            </template>
          </el-table-column>

          <el-table-column
            v-if="judge_show('CALLER_NAME')"
            align="center"
            min-width="150"
            label="Caller">
            <template slot-scope="scope" v-if="scope.row.caller_name != null && scope.row.caller_name != 'null'">
              {{scope.row.caller_name}}
            </template>
          </el-table-column>

          <el-table-column
            v-if="judge_show('CALLEE_NAME')"
            align="center"
            min-width="150"
            label="Callee">
            <template slot-scope="scope" v-if="scope.row.callee_name != null && scope.row.callee_name != 'null'">
              {{scope.row.callee_name}}
            </template>
          </el-table-column>

          <el-table-column
            v-if="judge_show('CATEGORY')"
            align="center"
            min-width="150"
            label="Category">
            <template slot-scope="scope">
              {{translate_category(scope.row.category)}}
            </template>
          </el-table-column>

          <el-table-column
          v-if="judge_show('REFERRAL_SOURCE')"
            align="center"
            min-width="150"
            label="Referral Source">
            <template slot-scope="scope">
              {{translate_source(scope.row.referral_source)}}
            </template>
          </el-table-column>
          <el-table-column
          v-if="judge_show('NEW_CLIENT')"
            align="center"
            min-width="150"
            label="New Client">
            <template slot-scope="scope">
              {{translate_new_client(scope.row.new_client)}}
            </template>
          </el-table-column>
          <el-table-column
          v-if="judge_show('CONVERSION')"
            align="center"
            min-width="150"
            label="Conversion">
            <template slot-scope="scope" v-if="scope.row.conversion != null">
              {{scope.row.conversion ? 'Yes' : 'No'}}
            </template>
          </el-table-column>

          <el-table-column
          v-if="judge_show('APPOINTMENTS')"
            align="center"
            min-width="150"
            label="Appointments">
            <template slot-scope="scope" v-if="scope.row.appointments != null">
              {{scope.row.appointments ? 'Yes' : 'No'}}
            </template>
          </el-table-column>

          <el-table-column
          v-if="judge_show('AI_ANALYTICS')"
            align="center"
            min-width="150"
            label="AI Analytics">
            <template slot-scope="scope" v-if="scope.row.ai_analytics != null">
              {{scope.row.ai_analytics ? 'Yes' : 'No'}}
            </template>
          </el-table-column>

          <el-table-column
          v-if="judge_show('CUSTOMER_SATISFACTION')"
            align="center"
            min-width="200"
            sortable
            prop="customer_satisfaction"
            label="Customer Satisfaction">
            <template slot-scope="scope" v-if="scope.row.customer_satisfaction != null">
              {{scope.row.customer_satisfaction}}<i class="el-icon-star-on" style="margin-left: 1px;color: gold;font-size: 18px;"></i>
            </template>
          </el-table-column>

          <el-table-column
          v-if="judge_show('ISSUED_RESOLVED')"
            align="center"
            min-width="160"
            label="Issued Resolved">
            <template slot-scope="scope" v-if="scope.row.issued_resolved != null">
              {{scope.row.issued_resolved}}<i class="el-icon-star-on" style="margin-left: 1px;color: gold;font-size: 18px;"></i>
            </template>
          </el-table-column>

          <el-table-column
          v-if="judge_show('CALL_STATUS')"
            align="center"
            min-width="150"
            label="Status">
            <template slot-scope="scope">
              <el-tag type="success" size="small" v-if="scope.row.call_status == 'Answered'"><i class="el-icon-success" style="margin-right:3px;"></i>Answered</el-tag>
              <el-tag type="info" size="small" v-if="scope.row.call_status == 'Unknown'"><i class="el-icon-question" style="margin-right:3px;"></i>Unknown</el-tag>
              <el-tag type="warning" size="small" v-if="scope.row.call_status == 'Busy'"><i class="el-icon-warning" style="margin-right:3px;"></i>Busy</el-tag>
              <el-tag type="danger" size="small" v-if="scope.row.call_status == 'Missed call'"><i class="el-icon-error" style="margin-right:3px;"></i>Missed call</el-tag>
            </template>
          </el-table-column>

          <el-table-column
          v-if="judge_show('CALL_DURATION')"
            align="center"
            min-width="120"
            sortable
            prop="call_duration"
            label="Duration">
            <template slot-scope="scope">
              {{secondsToTime(scope.row.call_duration)}}
            </template>
          </el-table-column>

          <el-table-column
          v-if="judge_show('KEYWORDS')"
            align="center"
            min-width="120"
            label="Keywords">
            <template slot-scope="scope" v-if="scope.row.keywords">
              <el-tag size="mini" style="font-size: 12px;" v-for="(item,index) of scope.row.keywords" :key="index">{{item}}</el-tag>
            </template>
          </el-table-column>

          <el-table-column
          v-if="judge_show('COMMENT')"
            align="center"
            min-width="300"
            label="Comment">
            <template slot-scope="scope">
              <div style="display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;">{{scope.row.comment}}</div>
            </template>
          </el-table-column>

          <el-table-column
          v-if="judge_show('SUMMARY')"
            align="center"
            min-width="300"
            label="Summary">
            <template slot-scope="scope">
              <div style="display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;">{{scope.row.summary}}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="Action"
            align="center"
            min-width="100">
            <template slot-scope="scope">
              <el-link type="primary" title="Detail" @click.stop="show_edit(scope.row.call_sid)"><i class="font-size-16 el-icon-search"></i></el-link>
            </template>
          </el-table-column>
        </el-table>
      <div class="pager">
        <el-pagination
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :page-size="page_size"
          :total="totalRows">
        </el-pagination>
      </div>
    </div>

    <show ref="viewForm"></show>
    <table-title-setting ref="tableTitleSetting" @ok="getDatas(1)"></table-title-setting>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { getActionApi,downFileApi,putActionApi } from '@/network/manageApi';
  import Show from './callInquiries/show'
  import TableTitleSetting from './callInquiries/tableTitleSetting'
  import moment from 'moment/moment';
  import * as echarts from 'echarts';
  import { INITIALIZATION_DATE_CALL } from '@/store/mutation-types'
  export default {
    name: 'CallInquiries',
    components: {
      Show,TableTitleSetting
    },
    data() {
      return {
        value:[],
        totalRows: 0,
        current_page: 1,
        page_size: 10,
        tableData: [],
        table_loading: false,
        search:'',
        sort: '',
        downloadLoading:false,
        status_map: {"Answered":"Answered", "Missed call":"Missed call",
        "Busy": "Busy", "Unknown":"Unknown"},
        customIcon: 'el-icon-arrow-down',
        category_data: [{value: 'APPOINTMENT', label: 'APPOINTMENT'}, {value: 'GENERAL_INQUIRY', label: 'GENERAL INQUIRY'},
        {value: 'CANCEL_APPOINTMENT', label: 'CANCEL APPOINTMENT'},{value: 'COMPLAINT', label: 'COMPLAINT'},{value: 'UNKNOWN', label: 'UNKNOWN'},
        {value: 'APPOINTMENT_CHANGE', label: 'APPOINTMENT CHANGE'},{value: 'APPOINTMENT_CONFIRM', label: 'APPOINTMENT CONFIRM'}],
        select_category: '',
        status_data: [{value: 'ANSWERED', label: 'ANSWERED'}, {value: 'MISSED_CALL', label: 'MISSED CALL'}],
        select_status: '',
        new_client_data: [{value: 'NEW_CLIENT', label: 'NEW CLIENT'}, {value: 'NOT_NEW_CLIENT', label: 'NOT NEW CLIENT'}],
        select_new_client: '',
        referral_source_data: [{value: 'GOOGLE', label: 'GOOGLE'}, {value: 'FACEBOOK', label: 'FACEBOOK'}, {value: 'INSTAGRAM', label: 'INSTAGRAM'},
        {value: 'LINKEDIN', label: 'LINKEDIN'}, {value: 'YELP', label: 'YELP'}, {value: 'WEBSITE', label: 'WEBSITE'}, {value: 'ETC', label: 'ETC'},
        {value: 'UNKNOWN', label: 'UNKNOWN'}],
        select_referral_source: '',
        selected_columns: ["CATEGORY","SUMMARY","CONVERSION","APPOINTMENTS","AI_ANALYTICS","KEYWORDS","CUSTOMER_SATISFACTION","ISSUED_RESOLVED","COMMENT","CALLER_NAME","CALLEE_NAME","NEW_CLIENT","REFERRAL_SOURCE","CALL_FROM","CALL_DURATION","CALL_DATETIME","CALL_STATUS"],
        dashBoardDataMain: {},
        dashBoardDataCallDistribution: {},
        dashBoardDataCallTrend: {},
        dashBoardDataCallSources: {},
        dash_board_total_duration: "",
        dash_board_avg_duration: "",
        action_item_list: [],
        remove_load: false,
        myChart:null,
        myPie1:null,
        myPie2:null
      }
    },
    computed: {

    },
    mounted() {
      window.addEventListener('resize', this.handleResize);
    },
    created(){
      if(!Vue.ls.get(INITIALIZATION_DATE_CALL)) {
        Vue.ls.set(INITIALIZATION_DATE_CALL, [moment().add(-1,'months').format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')])
      }
      this.value = Vue.ls.get(INITIALIZATION_DATE_CALL)
      this.initDashboard()
      this.initActionItem()
      this.getDatas(1)
    },
    methods:{
      go_show_all_action() {
        this.$router.push("/actionItemList");
      },
      go_show_call_list() {
        this.$router.push("/callInquiries");
      },
      handleResize() {
        if (this.myChart) {
          this.myChart.resize();
        }
      },
      due_time_show(time) {
        const someDate = moment(time);
        const isToday = someDate.isSame(moment(), 'day');
        const isTomorrow = someDate.isSame(moment().add(1, "days"), 'day');
        if(isToday) {
          return "Today";
        } else if(isTomorrow) {
          return "Tomorrow";
        } else {
          return someDate.format("MMM DD")
        }
      },
      async remove_item(item,index) {
        if(!this.remove_load) {
          this.remove_load = true
          let param = {show_item: false}
          let res = await putActionApi("/inquiry/call-inquiry/action-items/" + item.twilio_call_analysis_action_items_uuid + "/status-change", param);
          if(res.code == 200) {
            this.action_item_list.splice(index, 1)
          }
          this.remove_load = false
        }
      },
      initActionItem() {
        getActionApi("/inquiry/call-inquiry/main/action-items").then((res) => {
          this.action_item_list = res.data
        })
      },
      initPie1(zb){
        var chartDom = document.getElementById('myPie1');
        this.myPie1 = this.$echarts.init(chartDom);
        var option = {
          series: [
            {
              type: 'pie',
              radius: ['60%', '70%'],
              color:['#5EB1FF','#F0F0F0'],
              avoidLabelOverlap: false,
              labelLine: {
                show: false
              },
              label: {
                show: false,
                position: 'center'
              },
              data: [
                { value: zb, name: 'Answered' },
                { value: 100-zb, name: '' },
              ]
            }
          ]
        };
        this.myPie1.setOption(option)
      },
      initPie2(zb){
        var chartDom = document.getElementById('myPie2');
        this.myPie2 = this.$echarts.init(chartDom);
        var option = {
          series: [
            {
              type: 'pie',
              radius: ['60%', '70%'],
              color:['#DE7676','#F0F0F0'],
              avoidLabelOverlap: false,
              labelLine: {
                show: false
              },
              label: {
                show: false,
                position: 'center'
              },
              data: [
                { value: zb, name: 'Missed' },
                { value: 100-zb, name: '' },
              ]
            }
          ]
        };
        this.myPie2.setOption(option)
      },
      initBar(id,title,list, fullName){
        var chartDom = document.getElementById(id);
        this.myChart = this.$echarts.init(chartDom);
        var option = {
          title:{
            left: 'center',
            text: title
          },
          color: [
            '#5856D6',
          ],
          grid: {
            left: '4%',
            right: '4%',
            bottom: '15%',
            containLabel: true
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross'
            }
          },
          xAxis: [
            {
              type: 'category',
              data: fullName
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              name: title,
              type: 'bar',
              barWidth: 40,
              showBackground: true,

              emphasis: {
                focus: 'series'
              },
              data: list
            }
          ]
        };
        this.myChart.setOption(option)
        this.loading = false
      },
      padZero(num, length) {
          return String(num).padStart(length, '0');
      },
      initDashboard() {
        let param = {date_from:moment(this.value[0]).format('YYYY-MM-DD'),date_to:moment(this.value[1]).format('YYYY-MM-DD')}
        getActionApi("/inquiry/call-inquiry/main", param).then((res) => {
          this.dashBoardDataMain = res.data.main
          if(this.dashBoardDataMain.avg_quality_score)
          this.dashBoardDataMain.avg_quality_score_str = this.dashBoardDataMain.avg_quality_score.toFixed(2)

          this.dashBoardDataCallDistribution = res.data.call_distribution
          if(this.dashBoardDataCallDistribution.answered != 0) {
            this.dashBoardDataCallDistribution.answered_rate = Math.floor(this.dashBoardDataCallDistribution.answered * 100)
            this.dashBoardDataCallDistribution.missed_rate = 100 - this.dashBoardDataCallDistribution.answered_rate
          } else {
            this.dashBoardDataCallDistribution.answered_rate = Math.floor(this.dashBoardDataCallDistribution.answered * 100)
            this.dashBoardDataCallDistribution.missed_rate = Math.floor(this.dashBoardDataCallDistribution.missed * 100)
          }
          if(this.dashBoardDataCallDistribution.total_duration)
          this.dash_board_total_duration = this.secondsToTime(this.dashBoardDataCallDistribution.total_duration)
          if(this.dashBoardDataCallDistribution.avg_duration)
          this.dash_board_avg_duration = this.secondsToTime(this.dashBoardDataCallDistribution.avg_duration)

          this.dashBoardDataCallTrend = res.data.weekly_call_trends

          let row_name = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]
          let datas = [this.dashBoardDataCallTrend.Monday,
          this.dashBoardDataCallTrend.Tuesday,
          this.dashBoardDataCallTrend.Wednesday,
          this.dashBoardDataCallTrend.Thursday,
          this.dashBoardDataCallTrend.Friday,
          this.dashBoardDataCallTrend.Saturday,
          this.dashBoardDataCallTrend.Sunday]
          this.initBar("echarts_div", "", datas, row_name);
          this.initPie1(this.dashBoardDataCallDistribution.answered_rate)
          this.initPie2(this.dashBoardDataCallDistribution.missed_rate)

          let array = []
          let obj_google = {name: "GOOGLE", value: res.data.referral_sources.GOOGLE, rate: 0};
          let obj_facebook = {name: "FACEBOOK", value: res.data.referral_sources.FACEBOOK, rate: 0};
          let obj_instagram = {name: "INSTAGRAM", value: res.data.referral_sources.INSTAGRAM, rate: 0};
          let obj_linkedin = {name: "LINKEDIN", value: res.data.referral_sources.LINKEDIN, rate: 0};
          let obj_yelp = {name: "YELP", value: res.data.referral_sources.YELP, rate: 0};
          let obj_website = {name: "WEBSITE", value: res.data.referral_sources.WEBSITE, rate: 0};
          // let obj_etc = {name: "ETC", value: res.data.referral_sources.ETC, rate: 0};
          // let obj_unknown = {name: "UNKNOWN", value: res.data.referral_sources.UNKNOWN, rate: 0};
          array.push(obj_google)
          array.push(obj_facebook)
          array.push(obj_instagram)
          array.push(obj_linkedin)
          array.push(obj_yelp)
          array.push(obj_website)
          // array.push(obj_etc)
          // array.push(obj_unknown)
          array.sort((a, b) => (b.value - a.value))
          if(array[0].value != 0) {
            let max_value = array[0].value
            for(let item of array) {
              item.rate = Math.floor(item.value/max_value * 100)
            }
          }
          this.dashBoardDataCallSources = array
        })
      },
      show_setting_cols() {
        this.$refs.tableTitleSetting.init()
      },
      judge_show(item) {
        return this.selected_columns.includes(item)
      },
      secondsToTime(seconds) {
        if(seconds) {
          if(seconds > 3600) {
            return this.padZero(Math.floor(seconds/3600), 2) + ":" + this.padZero(Math.floor(seconds%3600/60), 2) + ":" + this.padZero(Math.floor(seconds%60), 2)
          } else {
            return this.padZero(Math.floor(seconds/60), 2) + ":" + this.padZero(Math.floor(seconds%60), 2)
          }
        } else {
          return "00:00"
        }
      },
      translate_source(status) {
        if(status == null || status == 'UNKNOWN') {
          return "";
        } else {
          return status
        }
      },
      moment,
      order_change(column, prop, order ) {
        this.sort = ''
        if(column.order != null){
          this.sort = column.prop + '_'
          if(column.order == "ascending")
            this.sort = this.sort + 'asc'
          else
            this.sort = this.sort + 'desc'
        }
        this.getDatas(1)
      },
      format_phone(localNumber, countryCode) {
        const phoneFormats = {          "+1": "(XXX) XXX-XXXX", // USA, Canada          "+44": "07XXX XXXXXX",   // UK Local Mobile          "+91": "XXXXX-XXXXX",   // India          "+61": "XXXX XXX XXX",  // Australia          "+81": "XXX-XXXX-XXXX", // Japan          "+49": "XXXX XXXXXXX",  // Germany          "+33": "X XX XX XX XX",  // France          "+55": "(XX) XXXXX-XXXX" // Brazil        };
        let format = phoneFormats[countryCode] || "XXXX-XXXX-XXXX";
        let digits = localNumber.replace(/\D/g, "");
        let formattedNumber = "";        let digitIndex = 0;        // +44 07577 318158        for (let char of format) {            if (char === "X" && digitIndex < digits.length) {                formattedNumber += digits[digitIndex];                digitIndex++;            } else {                formattedNumber += char;            }        }        return `${countryCode} ${formattedNumber}`;      },
      process_phone_number_format(phone) {
        if(!phone) {
          return "";
        }
        if(phone == "Anonymous"
        || phone == "anonymous") {
          return "Anonymous";
        }
        let countryCode = this.get_phone_countryCode(phone)
        let phone_cl = phone.replaceAll("-", "").replaceAll(countryCode, "");
        if(countryCode == "+44") {
          if(phone_cl.indexOf("7") == 0 && phone_cl.length == 10) {
            phone_cl = phone_cl.substring(1);
          } else if(phone_cl.indexOf("07") == 0 && phone_cl.length == 11) {
            phone_cl = phone_cl.substring(2);
          }
        }
        return this.format_phone(phone_cl,countryCode)
      },
      get_phone_countryCode(phone) {
        if(phone.indexOf("+55") != -1) {
          return "+55";
        } else if(phone.indexOf("+33") != -1) {
          return "+33";
        } else if(phone.indexOf("+49") != -1) {
          return "+49";
        } else if(phone.indexOf("+81") != -1) {
          return "+81";
        } else if(phone.indexOf("+61") != -1) {
          return "+61";
        } else if(phone.indexOf("+91") != -1) {
          return "+91";
        } else if(phone.indexOf("+44") != -1) {
          return "+44";
        } else if(phone.indexOf("+1") != -1) {
          return "+1";
        } else {
          return ""
        }
      },
      translate_new_client(str){
        if(str == null || str == "" || str == "UNKNOWN") {
          return "";
        } else if(str == "YES") {
          return "Yes"
        } else if(str == "NO") {
          return "No"
        }
      },
      translate_status(status) {
        if(status) {
          return this.status_map[status]
        }
        return;
      },
      translate_category(status) {
        if(status) {
          return status.replaceAll("_", " ")
        }
        return;
      },
      show_edit(id) {
        this.$refs.viewForm.init(id)
      },
      rowClick(row){
        this.$refs.viewForm.init(row.call_sid)
      },
      searchFunction(){
        this.getDatas(1)
      },
      download(){
        if(this.downloadLoading)
          return
        const that = this
        that.downloadLoading = true
        let params = {date_from:moment(this.value[0]).format('YYYY-MM-DD'),date_to:moment(this.value[1]).format('YYYY-MM-DD'),search:this.search.trim()}
        if(this.sort != '')
          params.sorting = this.sort
        if(this.select_category != '')
          params.category_filter = this.select_category
        if(this.select_status != '')
          params.call_status_filter = this.select_status
        if(this.select_new_client != '')
          params.new_client_filter = this.select_new_client
        if(this.select_referral_source != '')
          params.referral_source_filter = this.select_referral_source
        downFileApi("/inquiry/call-inquiry/download1?size=" + this.page_size + "&page=" + this.current_page,params).then((res) => {
          const url = window.URL.createObjectURL(new Blob([res]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download','call_inquiries.xlsx')
          document.body.appendChild(link)
          link.click()
          that.downloadLoading = false
        })
      },
      changeTime(e){
        Vue.ls.set(INITIALIZATION_DATE_CALL, this.value)
        this.initDashboard()
        this.getDatas(1)
      },
      async getDatas(initSize) {
        if(initSize == 1) {
          let res = await getActionApi("/inquiry/call-inquiry/columns")
          this.selected_columns = res.data.selected_columns
        }
        this.current_page = initSize
        this.table_loading = true
        let params = {date_from:moment(this.value[0]).format('YYYY-MM-DD'),date_to:moment(this.value[1]).format('YYYY-MM-DD'),search:this.search.trim()}
        if(this.sort != '')
          params.sorting = this.sort
        if(this.select_category != '')
          params.category_filter = this.select_category
        if(this.select_status != '')
          params.call_status_filter = this.select_status
        if(this.select_new_client != '')
          params.new_client_filter = this.select_new_client
        if(this.select_referral_source != '')
          params.referral_source_filter = this.select_referral_source
        let data_res = await getActionApi("/inquiry/call-inquiry1?size=" + this.page_size + "&page=" + this.current_page,params)
        this.tableData = data_res.data
        this.totalRows = data_res.page.totalElements
        this.table_loading = false
      },
      handleCurrentChange(val) {
        this.getDatas(val)
      }
    }
  }
</script>

<style scoped>
  body{overflow-x: hidden;}
  *{font-size:16px;font-size:inherit;box-sizing: border-box;word-break:normal;}
  #home{background-color:#F8F9FA;padding:20px;display: grid;gap: 20px;}
  .content{background-color: #f9fafb;display: grid;gap: 20px;border-radius: 16px;}
  .title{color:#2D3648;font-size: 20px;font-weight: bold;display: flex;justify-content: space-between;align-items: center;}
  .title div{display: flex;align-items: center;}
  .title div *{padding:10px 16px;font-size: 14px;}
  .pager{display: flex;justify-content: center;}
  .font-size-16 {font-size: 20px;}
  .margin-top-switch {margin-top: 10px;}
  .center{display:inline-grid;grid-gap: 10px;grid-template-columns: 300px 300px 300px 100%;}
  .avatar-uploader-icon {font-size: 18px;color: #8c939d;}
  .headImageShow {width: 76px;height: 76px;border-radius: 4px;}
  .pannel{display:grid;grid-template-columns: 1fr 1fr 1fr 1fr;grid-gap: 20px;}
  .pannel .item{box-shadow: 0px 1px 2px 1px rgba(0,0,0,0.08);padding:20px;border-radius: 8px;background-color: #ffffff;}
  .pannel .item .div{display: flex;align-items: center;}
  .pannel .item .div .span{font-size:20px;color:#5856D6;margin-right:10px;width: 45px;height:45px;border-radius: 50%;display: flex;align-items: center;justify-content: center;background-color: #EEEEFF;}
  .pannel .item .div p{display: flex;flex-direction: column;font-size: 13px;color:#777777;}
  .pannel .item .div p span{font-size: 24px;font-weight: bold;color:#000000;}
  .pannel .item .div:last-child{display: flex;justify-content: flex-end;color: #2D3648;font-size: 18px;font-weight: bold;}
  .pageH4{font-size: 15px;color:#666666;display: flex;justify-content: space-between;}
  .pageH4 a{color:#5856d6;cursor: pointer;font-weight: normal;}
  .contentBoard{background-color: #ffffff;border-radius: 8px;padding:30px;box-shadow: 0px 1px 2px 1px rgba(0,0,0,0.05);}
  .callDistribution .huan{display: grid;grid-template-columns: 1fr 1fr;}
  .callDistribution .grid{display: grid;grid-template-columns: 1fr;grid-gap: 20px;margin-top:20px;}
  .callDistribution .grid div{padding:16px;background-color: #f9fafb;font-weight:bold;border-radius: 8px;color: #777777;font-size: 13px;display: flex;flex-direction: column;}
  .callDistribution .grid div p{display: flex;justify-content: flex-end;margin-top: 10px;}
  .callDistribution .grid div b{font-size: 18px;color:#000000;}
  .sources .item{margin-top:16px;}
  .sources .item .info{display: flex;justify-content: space-between;font-size: 14px;}
  .sources .item .bar{width: 100%;height: 10px;background-color: #e5e7ec;border-radius: 10px;display: flex;margin-top:6px;}
  .sources .item .bar div{background-color: #5856d6;border-radius: 10px;}
  .actionItem .grid{display: grid;grid-gap: 14px;grid-template-columns: 1fr;margin-top: 10px;}
  .actionItem .item{padding:16px;border-radius: 4px;display: flex;flex-direction: column;color:#888888;font-size: 14px;}
  .actionItem .item .info{display: flex;justify-content: space-between;font-weight: bold;margin-bottom: 2px;color:#000000;font-size: 16px;}
  .actionItem .item .info i{font-weight: normal;color:#888888;cursor: pointer;}
  .cdClass{display: grid;grid-template-columns: 1fr 1fr;gap:20px;}
  @media (max-width: 768px) {
    .title{flex-direction: column;}
    .title div{margin-top:20px;}
    .center{display: grid;grid-template-columns: 1fr;}
    .content{padding:20px 5px;}
    .pannel{grid-template-columns: 1fr;}
    .cdClass{grid-template-columns: 1fr;}
    .callDistribution .grid{grid-template-columns: 1fr 1fr;}
  }
  @media screen and (min-width: 769px) and (max-width: 1024px) {
    .center{display:inline-grid;grid-gap: 10px;grid-template-columns: 250px 200px 100%;}
  }
  .setting:hover {color: #000000 !important;}
  .dismiss_btn {cursor: pointer;font-weight: normal;font-size: 12px;color: #5856d6;}
  .dismiss_btn:hover {color: #0300b3;}
  .round-header-table {
    /* border-radius: 8px; */
    /* overflow: hidden; */
  }

  .round-header-table .el-table__header-wrapper {
    border-radius: 8px 8px 0 0;
    overflow: hidden;
  }

  .round-header-table .el-table__header th.el-table__cell {
    background-color: #f5f7fa;
    color: #303133;
    font-weight: bold;
    border: none; /* 去除默认边框 */
    border-right: 1px solid #e8e8e8; /* 自定义右侧边框 */
  }

  .round-header-table .el-table__header th.el-table__cell:first-child {
    border-radius: 8px 0 0 0;
  }

  /* 最后一个表头单元格 - 右上角圆角 */
  .round-header-table .el-table__header th.el-table__cell:last-child {
    border-radius: 0 8px 0 0;
    border-right: none; /* 去除最后一个单元格的右边框 */
  }

  /* 处理表格边框 */
  .round-header-table .el-table__body td.el-table__cell {
    border-right: 1px solid #e8e8e8;
  }

  .round-header-table .el-table__body td.el-table__cell:last-child {
    border-right: none;
  }

  /* 去除表头底部边框，通过添加表格顶部边框实现视觉连续 */
  .round-header-table .el-table__header {
    border-bottom: none;
  }

  .round-header-table .el-table__body {
    border-top: 1px solid #e8e8e8;
  }

  /* 如果使用scoped样式，需要使用::v-deep穿透 */
  ::v-deep .round-header-table .el-table__header-wrapper {
    border-radius: 8px 8px 0 0;
    overflow: hidden;
  }

  ::v-deep .round-header-table .el-table__header th.el-table__cell {
    background-color: #f5f7fa;
    color: #303133;
    font-weight: bold;
    border: none;
    border-right: 1px solid #e8e8e8;
  }

  ::v-deep .round-header-table .el-table__header th.el-table__cell:first-child {
    border-radius: 8px 0 0 0;
  }

  ::v-deep .round-header-table .el-table__header th.el-table__cell:last-child {
    border-radius: 0 8px 0 0;
    border-right: none;
  }
  ::v-deep .el-table--border, .el-table--group {
    border: 1px solid #EBEEF5;
    border-radius: 8px 8px 0 0;
  }
</style>
